import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ToastProvider } from './components/ui/Toast';
import ProtectedRoute from './routes/ProtectedRoute';
import Login from './routes/Login';
import PostsList from './routes/PostsList';
import PostEditor from './routes/PostEditor';
import AppHeader from './components/AppHeader';
import './App.css';

function App() {
  return (
    <ToastProvider>
      <AuthProvider>
        <Router>
          <div className="min-h-screen bg-gray-50">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/posts"
                element={
                  <ProtectedRoute>
                    <AppHeader />
                    <PostsList />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/posts/:id"
                element={
                  <ProtectedRoute>
                    <AppHeader />
                    <PostEditor />
                  </ProtectedRoute>
                }
              />
              <Route path="/" element={<Navigate to="/posts" replace />} />
            </Routes>
          </div>
        </Router>
      </AuthProvider>
    </ToastProvider>
  );
}

export default App;